import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
		primary: {
			main: '#F4D03F',
		},
		secondary: {
			main: '#000000',
		},
	},
});

export default theme;
